import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Teodor Sandu
 * id DD107169-7A9D-452F-8DE9-2736B6FB7851
 * name ceiling-light-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ceiling-light-outline.svg
 * tags
 * - Home Automation 
 */
export const CeilingLightOutlineIcon = createSvgIcon(<><path d="M14.76 11L16.76 15H7.24L9.24 11H14.76M13 4H11V9H8L4 17H20L16 9H13V4M14 18H10C10 19.11 10.9 20 12 20S14 19.11 14 18Z" /></>, 'CeilingLightOutlineIcon');
export default CeilingLightOutlineIcon